import { resolveCarrierCodeFromOptionName } from 'features/transaction-details/helpers/resolveCarrierCode';

export const UX_CARRIER_CODE = 'UX';

const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;

/** Vigencia BSP para autorizaciones Air Europa (UX). */
export const UX_AUTHORIZATION_CROSS_VALIDITY_MS = 48 * HOUR_MS;

/** Vigencia BSP para el resto de aerolíneas. */
export const DEFAULT_AUTHORIZATION_CROSS_VALIDITY_MS = 15 * DAY_MS;

export interface AuthorizationCrossExpiryWarning {
	message: string;
}

export const resolveAuthorizationCarrierCode = (
	chargedAgainstOptionCode?: string | null,
	chargedAgainstOptionName?: string | null,
): string | null => {
	const code = chargedAgainstOptionCode?.trim();
	if (code) return code.toUpperCase();
	if (!chargedAgainstOptionName) return null;
	return resolveCarrierCodeFromOptionName(chargedAgainstOptionName)?.toUpperCase() ?? null;
};

export const getAuthorizationCrossValidityMs = (carrierCode: string | null | undefined): number =>
	carrierCode === UX_CARRIER_CODE ? UX_AUTHORIZATION_CROSS_VALIDITY_MS : DEFAULT_AUTHORIZATION_CROSS_VALIDITY_MS;

export const isAuthorizationCrossExpiryExceeded = (
	createdAt: string,
	carrierCode: string | null | undefined,
): boolean => {
	const created = new Date(createdAt);
	if (Number.isNaN(created.getTime())) return false;
	const elapsedMs = Date.now() - created.getTime();
	return elapsedMs > getAuthorizationCrossValidityMs(carrierCode);
};

export const buildAuthorizationCrossExpiryWarningMessage = (carrierCode: string | null | undefined): string => {
	if (carrierCode === UX_CARRIER_CODE) {
		return 'Es probable que este cruce venga rechazado en BSP debido a que las autorizaciones de UX tienen una vigencia de 48hs. Deberías dar de baja esta autorización y crear una nueva antes de hacer la emisión y el cruce para evitar penalidades en BSP. Consultá con tu líder.';
	}

	return 'Es probable que este cruce venga rechazado en BSP debido a que las autorizaciones tienen una vigencia de 15 días desde su creación. Deberías dar de baja esta autorización y crear una nueva antes de hacer la emisión y el cruce para evitar penalidades en BSP. Consultá con tu líder.';
};

export const getAuthorizationCrossExpiryWarning = (
	createdAt: string,
	chargedAgainstOptionCode?: string | null,
	chargedAgainstOptionName?: string | null,
): AuthorizationCrossExpiryWarning | null => {
	const carrierCode = resolveAuthorizationCarrierCode(chargedAgainstOptionCode, chargedAgainstOptionName);
	if (!isAuthorizationCrossExpiryExceeded(createdAt, carrierCode)) return null;

	return {
		message: buildAuthorizationCrossExpiryWarningMessage(carrierCode),
	};
};
